import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2db21745"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, watch, onMounted, PropType } from 'vue';
import EntityInfo from '@/components/forms/doctor/EntityInfo.vue';
import Fieldset from 'primevue/fieldset';
import { Doctor } from '@/interfaces/Doctor';


export default /*#__PURE__*/_defineComponent({
  __name: 'EntityForm',
  props: {
  modelValue: {
    type: Object as PropType<Doctor>,
    default: () => ({})
  }
},
  emits: ['update:entityFormValidationChangeState'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const thisDoctor = ref<Doctor>(props.modelValue || ({} as Doctor));

const entityFormValidationChangeState = (newValue) => {
  emit('update:entityFormValidationChangeState', newValue);
};

watch(
  () => props.modelValue,
  (newValue) => {
    thisDoctor.value = newValue;
  }
);

onMounted(async () => {
  if (!thisDoctor.value.entity) {
    thisDoctor.value.entity = {
      id: '',
      identityCard: '',
      entityBank: '',
      entityIban: '',
      entityCui: '',
      entityName: '',
      entityCounty: '',
      entityCountyCode: '',
      entityCity: '',
      entityStreet: '',
      invoiceSerial: '',
      invoiceCurrentNumber: '',
      contractNumber: 0,
      contractDate: ''
    };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Fieldset), {
      legend: "Entitate comercială",
      pt: {
      legend: {
        style: 'padding: 0.75rem !important;'
      }
    }
    }, {
      default: _withCtx(() => [
        _createVNode(EntityInfo, {
          modelValue: thisDoctor.value.entity,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((thisDoctor.value.entity) = $event)),
          "onUpdate:entityFormValidationChangeState": entityFormValidationChangeState
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _hoisted_1
  ], 64))
}
}

})